import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// 🔐 REQUEST INTERCEPTOR (token attach)
api.interceptors.request.use(
  (config) => {
    const url = config?.url || "";
    const adminToken = localStorage.getItem("ospf_admin_token");
    const memberToken = localStorage.getItem("ospf_member_token");
    const legacyToken = localStorage.getItem("ospf_token");
    let token = null;

    if (url.startsWith("/admin")) {
      token = adminToken || legacyToken;
    } else if (
      url.startsWith("/member") ||
      url.startsWith("/members") ||
      url.startsWith("/membership")
    ) {
      token = memberToken || adminToken || legacyToken;
    } else {
      token = memberToken || adminToken || legacyToken;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// 🚨 RESPONSE INTERCEPTOR (auto logout on 401)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const pathname = window.location.pathname;

      // 🔥 token expired or invalid
      if (pathname.startsWith("/admin")) {
        localStorage.removeItem("ospf_admin_token");
      } else if (pathname.startsWith("/member") || pathname.startsWith("/membership")) {
        localStorage.removeItem("ospf_member_token");
      } else {
        localStorage.removeItem("ospf_admin_token");
        localStorage.removeItem("ospf_member_token");
        localStorage.removeItem("ospf_token");
      }

      // optional: redirect to the matching login page
      if (pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      } else if (
        pathname.startsWith("/member") ||
        pathname.startsWith("/membership")
      ) {
        window.location.href = "/member/login";
      } else if (pathname !== "/member/login") {
        window.location.href = "/member/login";
      }
    }

    return Promise.reject(error);
  },
);

// 🧠 ERROR FORMATTER
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;

  if (!detail) return err?.message || "Something went wrong.";

  if (typeof detail === "string") return detail;

  if (Array.isArray(detail)) {
    return detail
      .map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }

  if (typeof detail?.msg === "string") return detail.msg;

  return String(detail);
}
